import { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import ArticleCard from '@/components/feature/ArticleCard';
import { allCategories, sortByTime, allArticles } from '@/utils/news';

const PAGE_SIZE = 5;

export default function LatestNews() {
  const [tab, setTab] = useState('all');
  const [visible, setVisible] = useState(PAGE_SIZE);

  const tabs = [{ slug: 'all', name: '全部' }, ...allCategories.map((c) => ({ slug: c.slug, name: c.name }))];

  const filtered = useMemo(() => {
    const list = tab === 'all' ? allArticles : allArticles.filter((item) => item.category === tab);
    return sortByTime(list);
  }, [tab]);

  const shown = filtered.slice(0, visible);

  const handleTab = (slug: string) => {
    setTab(slug);
    setVisible(PAGE_SIZE);
  };

  return (
    <section>
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
        <h2 className="font-heading text-lg font-bold text-foreground-900 md:text-xl">最新资讯</h2>
        <div className="flex items-center gap-1 rounded-full bg-background-200 p-1">
          {tabs.map((item) => (
            <button
              key={item.slug}
              type="button"
              onClick={() => handleTab(item.slug)}
              className={`whitespace-nowrap rounded-full px-3 py-1 text-xs font-medium transition-colors ${
                tab === item.slug
                  ? 'bg-primary-500 text-background-50 dark:text-foreground-950'
                  : 'text-foreground-600 hover:text-primary-600'
              }`}
            >
              {item.name}
            </button>
          ))}
        </div>
      </div>

      {shown.length === 0 ? (
        <div className="flex flex-col items-center justify-center rounded-lg border border-background-200 bg-background-50 py-16 text-center">
          <div className="flex h-12 w-12 items-center justify-center text-3xl text-foreground-300">
            <i className="ri-inbox-line"></i>
          </div>
          <p className="mt-3 text-sm text-foreground-500">暂无当前热点</p>
        </div>
      ) : (
        <div className="flex flex-col gap-4">
          {shown.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      )}

      {visible < filtered.length && (
        <div className="mt-6 flex justify-center">
          <button
            type="button"
            onClick={() => setVisible((v) => v + PAGE_SIZE)}
            className="rounded-md border border-background-300 bg-background-50 px-6 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            加载更多资讯
            <i className="ri-arrow-down-s-line ml-1"></i>
          </button>
        </div>
      )}

      {visible >= filtered.length && shown.length > 0 && (
        <div className="mt-6 flex items-center justify-center gap-2 text-xs text-foreground-400">
          <span className="h-px w-8 bg-background-300"></span>
          已展示全部内容
          <span className="h-px w-8 bg-background-300"></span>
        </div>
      )}

      <div className="mt-4 text-center">
        <Link
          to={`/category/${tab === 'all' ? allCategories[0].slug : tab}`}
          className="text-xs text-primary-600 transition-colors hover:text-primary-700"
        >
          进入分类页查看更多 →
        </Link>
      </div>
    </section>
  );
}